/** Keep the originating module's identity while its shared creation form is open. */
export function visualRoute(pathname:string, search:string, state:unknown):string {
  if(pathname!=='/lancamentos')return pathname
  const origin=(state as {financialOrigin?:unknown}|null)?.financialOrigin
  const creation=new URLSearchParams(search).get('novo')
  if(origin==='/pagar'&&creation==='despesa')return origin
  if(origin==='/receber'&&creation==='receita')return origin
  return pathname
}
